import { useReactFlow, useStoreApi } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useSelectAllShortcut(onSelectAll: () => void) {
  const { getNodes, setNodes } = useReactFlow();
  const store = useStoreApi();

  useKeyboardShortcut(
    // shift unspecified — preserves original behavior where the listener
    // fires on both Cmd+A and Cmd+Shift+A (useDeselectShortcut also handles
    // the Cmd+Shift+A case independently).
    { key: 'a', meta: true },
    (e) => {
      e.preventDefault();
      onSelectAll();
      setNodes(getNodes().map((n) => ({ ...n, selected: true })));
      store.setState({ nodesSelectionActive: true });
    },
  );
}
